import { gql } from '@apollo/client';

export const getProducts = gql`
  query GetProducts($sessionId: String!) {
    products(sessionId: $sessionId) {
      id
      name
      identifier
      type
      usp
      description
      active
      associatedSuppliers
      price
      main
      customFields {
        pvMultipleOptions
        pvOptionsDynamicProduct
        pvSortOrder
      }
    }
  }
`;

export default getProducts;
